import { SELECTED_FOLDERABLE_OPERATION_SLICE_KEY } from 'FoldersApp/state/selected-folder-item/selected-folderable-operation.reducer';
import { FOLDERABLE_APP_CONFIG } from 'FoldersApp/constants/folderable-app-config.constants';
import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
import { FolderOperationsService } from 'FoldersApp/services/folder-operations.service';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
import { PageToastMessagesService } from 'NewAngular/features/components/toast-messages/page-toast-messages-service';
import { ToastMessageType } from 'NewAngular/features/components/toast-messages/toast-messages.enum';
import { setSelectedFolderableOperation } from 'FoldersApp/state/selected-folder-item/selected-folderable-operation.action';
import * as i0 from "@angular/core";
import * as i1 from "FoldersApp/services/folderable-collection-service-base.service";
import * as i2 from "FoldersApp/services/folder-operations.service";
import * as i3 from "NewAngular/features/components/toast-messages/page-toast-messages-service";
import * as i4 from "FoldersApp/services/selected-folderable.service";
import * as i5 from "../../../../../../ycharts/static/ts/features/components/rename-modal/rename-modal.component";
const _c0 = () => ({ selectedOperation: null });
/**
 * Modal that handles renaming folderable items.
 */
export class FolderableRenameModalComponent {
    constructor(folderCollectionService, folderOperationsService, toastMessagesService, folderableAppConfig, 
    // Only modal apps require an instance of SelectedFolderableService
    selectedFolderableService) {
        this.folderCollectionService = folderCollectionService;
        this.folderOperationsService = folderOperationsService;
        this.toastMessagesService = toastMessagesService;
        this.folderableAppConfig = folderableAppConfig;
        this.selectedFolderableService = selectedFolderableService;
        this.SELECTED_FOLDERABLE_ITEM_OPERATION_SLICE_KEY = SELECTED_FOLDERABLE_OPERATION_SLICE_KEY;
        this.setSelectedFolderableItemOperation = setSelectedFolderableOperation;
    }
    renameItem(item, name) {
        this.folderOperationsService.renameFolderableItem(item.itemType, item.id, name).subscribe({
            next: (response) => {
                this.folderCollectionService.refreshData();
                this.toastMessagesService.addMessage(response.message);
                if (this.folderableAppConfig.folderableAppType === FolderableAppType.MODAL &&
                    this.isRenamingSelectedItem(item)) {
                    // Updated the selected folderable with the new name to avoid making an additional request for
                    // folderable info (because only the name has changed).
                    this.selectedFolderableService.updateSelectedFolderableItem({
                        name,
                    });
                }
            },
            error: (response) => {
                this.toastMessagesService.addMessage(response.error.error_message, ToastMessageType.ERROR);
            },
        });
    }
    isRenamingSelectedItem(item) {
        const selection = this.selectedFolderableService.getSelection();
        if (selection === null)
            return false;
        const selectedItem = selection.item;
        return selection.resourceType === item.itemType && selectedItem.id === item.id;
    }
}
FolderableRenameModalComponent.ɵfac = function FolderableRenameModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableRenameModalComponent)(i0.ɵɵdirectiveInject(i1.FolderableCollectionServiceBase), i0.ɵɵdirectiveInject(i2.FolderOperationsService), i0.ɵɵdirectiveInject(i3.PageToastMessagesService), i0.ɵɵdirectiveInject(FOLDERABLE_APP_CONFIG), i0.ɵɵdirectiveInject(i4.SelectedFolderableService, 8)); };
FolderableRenameModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderableRenameModalComponent, selectors: [["ycn-folderable-rename-modal"]], standalone: false, decls: 1, vars: 3, consts: [[3, "renameItemHandler", "selectedOperationSlice", "clearSelectedOperationAction"]], template: function FolderableRenameModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-rename-modal", 0);
        i0.ɵɵlistener("renameItemHandler", function FolderableRenameModalComponent_Template_ycn_rename_modal_renameItemHandler_0_listener($event) { return ctx.renameItem($event.item, $event.name); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("selectedOperationSlice", ctx.SELECTED_FOLDERABLE_ITEM_OPERATION_SLICE_KEY)("clearSelectedOperationAction", ctx.setSelectedFolderableItemOperation(i0.ɵɵpureFunction0(2, _c0)));
    } }, dependencies: [i5.RenameModalComponent], encapsulation: 2 });
